import React, { useEffect, useState } from "react";
import sliderInner from '../assets/images/innerSlide01.jpg';
import VeerBanner from '../assets/images/veerBanner.jpg';
import inrSlr1 from '../assets/images/homepage-banner-fancy-flyer1.png';
import inrSlr2 from '../assets/images/homepage-banner-fancy-flyer2.png';
import inrSlr3 from '../assets/images/homepage-banner-fancy-flyer3.png';
import leafIcn from "../assets/images/slider-shape-5.png";
import CommonViewtheme from '../Components/CommonViewTheme';
import { FaHandPointRight } from "react-icons/fa";
import ThemeBaseRouting from "helper/ThemeBaseRouting";
import { useNavigate, Link } from "react-router-dom";
import subThemes from "../helper/SubThemes_List"
import veermodi from "../assets/images/veerModi.jpg"

function VeerBalDetailsPage() {
  const navigate = useNavigate();
  const [contentToDisplay, setContentToDisplay] = useState("No content available"); // State for dynamic content

  useEffect(() => {
    const themeName = localStorage.getItem('theme_name'); // Fetch theme from local storage
    const selectedSubTheme = localStorage.getItem('sub_themes'); // Fetch selected sub-theme from local storage

    console.log(themeName, selectedSubTheme, "theme")
    if (themeName && selectedSubTheme) {
      const subThemeList = subThemes[themeName] || []; // Get sub-themes based on the theme
      const foundSubTheme = subThemeList.find(subTheme => subTheme.value === selectedSubTheme); // Find the selected sub-theme

      if (foundSubTheme) {
        setContentToDisplay(foundSubTheme.content); // Set content based on the selected sub-theme
      } else {
        setContentToDisplay("No content available"); // Fallback content
      }
    } else {
      setContentToDisplay("No content available"); // Fallback content if theme or sub-theme is not found
    }
  }, []); // Run once on component mount

  const handleRoute = (name, url) => {
    localStorage.setItem('theme_name', name);
    navigate(url);
  };

  return (
    <>
      <section className="sliderSec sliderInnerSec">
        <img src={VeerBanner} alt="" />
        {/* <div className="sliderInrHdng" style={{top: "38%"}}>
          <h2>Veer Bal<span className="hdngBrkr">Diwas</span></h2>
        </div> */}
      </section>
      <section className='courseDesSec'>
        <div className='courserDesSecSldr'>
          <div className='detlSlrIcn1'><img src={inrSlr1} alt="" /></div>
          <div className='detlSlrIcn2'><img src={inrSlr2} alt="" /></div>
          <div className='detlSlrIcn3'><img src={inrSlr3} alt="" /></div>
          <div className='container-fluid'>
            <div className="backBtndiv">
              <a href="/save-energy" className="button green btn-login-signup loginBtnnewhm impctBtn">Back</a>
            </div>
            <div className="row justify-content-between">
              <div className='col-12 col-sm-12 col-md-10 col-lg-10 col-xxl-10 courseDesSldrLft'>
                <h2 className='detlHdng'>Veer Baal Diwas: A Tribute to Unmatched Bravery and Sacrifice:</h2>
                <p>On 9th January 2022, Hon’ble Prime Minister announced the annual celebration of ‘Veer Baal Diwas’ on 26th December.</p>
                <p>This day honors the unmatched sacrifice of Sahibzada Zorawar Singh and Sahibzada Fateh Singh, the sons of Shri Guru Gobind Singh Ji.</p>
                <p>The young Sahibzadas stood firm in their faith and principles, even in the face of death.</p>
                <p>Their bravery and devotion continue to inspire generations.</p>
                <p>'Veer Baal Diwas’ serves as a tribute to their courage and sacrifices for righteousness.</p>
              </div>
              {/* <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xxl-3 courseDesSldrLft'>
              <img src={veermodi} alt="" width="100%"/>
              </div> */}
            </div>
          </div>
        </div>
        <div className='courseDesSecBtmCnt'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-12 courseDesCntLft'>
                {/* <h2>Activity brief</h2>
                <div className='whatULrn'>
                  <ul>
                    <li><FaHandPointRight /> Switching off tube-lights, bulbs, electronic gadgets when not in use</li>
                    <li><FaHandPointRight /> Organize workshops for skilling students how to reuse and repurpose</li>
                    <li><FaHandPointRight /> Finding out the different sources of energy in school like solar, wind etc.,</li>
                  </ul>
                </div> */}
                <div className='skillLrn'>
                  {/* <ul>
                    {ThemeBaseRouting.map((theme, i) => (
                      <li onClick={() => handleRoute(theme.lable, theme.url)}><Link className="flex">{theme.lable}</Link></li>
                    ))}
                  </ul> */}
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="stackHolderSec detailPagGalrysec veerbal">
        <img className="slider__shape-13 stackholdrLf" src={leafIcn} alt="" />
        <div className="container">
          <span className="contact__shape-1"></span>
          <div className="imageListShowDiv">
            <CommonViewtheme />
          </div>
        </div>
      </section>
    </>
  )
}

export default VeerBalDetailsPage;